<mat-card class="float-card text-center" *ngIf="!!user">
	<mat-icon class="user-photo">account_circle</mat-icon>
	<mat-card-title class="center-icon">
		{{ user.name }}
		<button mat-icon-button (click)="editUser()">
			<mat-icon>mode_edit</mat-icon>
		</button>
	</mat-card-title>

	<mat-card-content>
		<mat-list>
			<mat-list-item class="border">
				<div class="list-item-wrapper">
					<div class="list-item-label">
						<mat-icon matListItemIcon>email</mat-icon>
						<span>Ел. пошта</span>
					</div>
					<b>{{ user.email }}</b>
				</div>
			</mat-list-item>
			<mat-list-item class="border">
				<div class="list-item-wrapper">
					<div class="list-item-label">
						<mat-icon matListItemIcon>language</mat-icon>
						<span>Мова</span>
					</div>
					<b>{{ user.lang }}</b>
				</div>
			</mat-list-item>
			<mat-list-item class="border">
				<div class="list-item-wrapper">
					<div class="list-item-label">
						<mat-icon matListItemIcon>record_voice_over</mat-icon>
						<span>Голос</span>
					</div>
					<mat-form-field class="voice-select-field">
						<mat-select [(value)]="selectedVoice" (selectionChange)="changeVoice()">
							<mat-option [disabled]="true" *ngIf="listVoices.length === 0">None</mat-option>
							<mat-option *ngFor="let voice of listVoices"
										[value]="voice.name">{{ voice.name }} {{ voice.lang }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</mat-list-item>
			<mat-list-item class="border" matTooltip="Незабаром" matTooltipPosition="above">
				<div class="list-item-wrapper">
					<div class="list-item-label">
						<mat-icon matListItemIcon>notifications</mat-icon>
						<span>Нотифікація</span>
					</div>
					<mat-slide-toggle
						(toggleChange)="toggleNotification()"
						[color]="color"
						[ngModel]="notification"
						[disabled]="not_disabled">
					</mat-slide-toggle>
				</div>
			</mat-list-item>
			<mat-list-item class="border">
				<div class="list-item-wrapper">
					<div class="list-item-label">
						<mat-icon matListItemIcon>brightness_2</mat-icon>
						<span>Темна тема</span>
					</div>
					<mat-slide-toggle
						(toggleChange)="themeService.toggleTheme()"
						[ngModel]="themeService.themeActive">
					</mat-slide-toggle>
				</div>
			</mat-list-item>
		</mat-list>
	</mat-card-content>

	<mat-card-actions class="card-actions">
		<button mat-raised-button (click)="logout()" color="primary">Вийти</button>
	</mat-card-actions>
</mat-card>
